module.exports = __webpack_public_path__ + "img/employee_shiftmanage.cb8b8acf.jpg";